<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-lg mt-4">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
            <div class="flex justify-between items-center mb-4">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Fulfillment Details
                </h3>
            </div>

            <div class="bg-white shadow overflow-hidden sm:rounded-md">
              <ul>
                <li v-for="otp in otps">
                  <a href="#" @click="viewDetails(otp)" class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
                    <div class="flex items-center px-4 py-4 sm:px-6">
                      <div class="min-w-0 flex-1 flex items-center">
                        <div class="flex-shrink-0">
                          <!-- user image/icon here -->
                        </div>
                        <otp-details :otp="otp" :warehouse-list="warehouseList" />
                      </div>
                      <div>
                        <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                        </svg>
                      </div>
                    </div>

                  </a>
                </li>
              </ul>
            </div>


          <modal :show="showModal" @closeModal="showModal = false">
            <div class="px-4 py-5 sm:p-6">
              <h3 class="text-lg leading-6 font-medium text-gray-900 mb-2">
                Fulfillment Details
              </h3>

              <otp-details :otp="selectedOtp" class="mb-3" :warehouse-list="warehouseList" />

              <div v-if="selectedOtp.otp_photo_path" class="my-2">
                <a :href="this.route('img.show', {type: 'otp', path: encodeURI(selectedOtp.otp_photo_path)})" target="_blank">
                  <img :src="this.route('img.show', {type: 'otp', path: encodeURI(selectedOtp.otp_photo_path), p: 'small'})" />
                </a>
              </div>

              <table class="min-w-full">
                <thead>
                <tr>
                  <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Code
                  </th>
                  <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Unit
                  </th>
                  <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Qty Delivered
                  </th>
                </tr>
                </thead>

                <tbody class="bg-white">
                <tr v-for="handover in selectedOtp.handover_items">
                  <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
                    {{ handover.item.item_code }}
                  </td>
                  <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
                    {{ handover.item.unit }}
                  </td>
                  <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
                    {{ handover.delivered_quantity }}
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </modal>
        </div>
    </div>
</template>
<script>
  import Modal from '@/Shared/Modal'
  import OtpDetails from './OtpDetails'
  export default {
    name: 'OrderFulfillmentDetails',
    components: {Modal, OtpDetails},
    props: {
      orderId: Number,
      isCustomer: Boolean,
      warehouses: Array,
    },

    data() {
      return {
        showModal: false,
        otps: [],
        selectedOtp: {},
        warehouseList: {},
      }
    },

    methods: {
      viewDetails(otp) {
        this.selectedOtp = otp
        this.showModal = true
      },

      setWarehouseListById() {
        if(this.warehouses) {
          this.warehouses.forEach((warehouse) => {
            this.warehouseList[warehouse.id] = warehouse.name;
          })
        }
      },

      showDetailsByOtpId(id) {
        if(id) {
          let otpDetais = this.otps.find(otp => otp.id == id);
          this.viewDetails(otpDetais)
        } else {
          this.selectedOtp = {};
          this.showModal = false;
        }
      },

      fetchOtps() {
        let url;

        if (this.isCustomer) {
          url = this.route('ajax.my-orders.otps', this.orderId)
        } else {
          url = this.route('ajax.customer.orders.otps', this.orderId)
        }

        this.$http.get(url).then(response => {
          this.otps = response.data
        })
      }
    },

    mounted() {
      this.setWarehouseListById();
      this.fetchOtps()
    }
  }
</script>
